import { updateKeyInStore } from 'App';
import {
  IncomeOutsideOfTheUsStateValues,
  TPerForeignEmployerItem,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  keyof IncomeOutsideOfTheUsStateValues | keyof TPerForeignEmployerItem
>[] = [
  {
    name: 'pleaseUploadFormW2',
    label: 'Please upload Form W2',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.income.wages.incomeOutsideOfTheUs.values.didYouReceivePaymentsFromANonUsEmployer',
  },
  {
    name: 'pleaseUploadSupportedDocumentation',
    label: 'Please upload supported documentation',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.wages.incomeOutsideOfTheUs.values.didYouReceiveStockBasedCompensationFromYourEmployer',
  },
  {
    name: 'uploadAnnualNonUsWageStatementFormForeignEmployers',
    label: 'Upload annual non-US wage statement form foreign employers',
    subLabel: () => <p>T4, Certificat de Salarie, PAYE, etc.</p>,
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];
